import React from "react";

import { Typography } from "@material-ui/core";
import Title from "../Text/Title/Title";
import Paragraph from "../Text/Paragraph/Paragraph";
import { StyledPage, Highlight, A } from "../../Styled-Components/styles";

const About = () => {
  return (
    <StyledPage>
      <Title title="About reForest" />

      <Typography variant="h2" gutterBottom>
        Why did I make <Highlight>reForest</Highlight>?
      </Typography>

      <Paragraph>
        I built this website to help get a crowd motivated to help <Highlight>our planet</Highlight>
        . I guess it is a bit like crowdfunding!
      </Paragraph>

      <Typography variant="h2" gutterBottom>
        What are our donations used for?
      </Typography>

      <Paragraph>
        1. Trees will be <Highlight>planted</Highlight>
      </Paragraph>
      <Paragraph>
        2. You will start taking positive steps towards{" "}
        <Highlight>reducing your carbon footprint</Highlight>
      </Paragraph>
      <Paragraph>
        3. And oh, you will get one of those cool squares (I like to call them{" "}
        <Highlight>Forest Segments</Highlight> ) on the map!
      </Paragraph>

      <Typography variant="h3" gutterBottom>
        So the leafy details...
      </Typography>
      <Paragraph>
        <Highlight>At least 80%</Highlight> of your donations will be sent directly to the great
        people at Ecologi through their tree purchasing scheme.
      </Paragraph>
      <Paragraph>
        If things go well, I plan to make <Highlight>all donations as public as possible</Highlight>
        . That will include incoming donations and outgoing payments. Think of Ecosia's{" "}
        <A href="https://blog.ecosia.org/ecosia-financial-reports-tree-planting-receipts/">
          open reports
        </A>
      </Paragraph>
      <Paragraph>
        With that said, the only major expenses we will face are card processing fees and other
        website-related costs. So making sure at least 80% goes directly to tree planting will be a
        priority.
      </Paragraph>

      <Typography variant="h2" gutterBottom>
        Who will plant the trees?
      </Typography>
      <Paragraph>
        I will start by using <A href="https://ecologi.com/gifting">Ecologi's tree packages</A>. I
        will the certificates on the website!
      </Paragraph>
      <Paragraph>
        The donations will be automatically logged, but actually purchasing the trees will be manual
        to start with. So there will be a lag before I can figure that out.
      </Paragraph>
    </StyledPage>
  );
};

export default About;
